import React, { Component } from 'react';
import { getStockData, getValuation } from '../lib/stockServices';

class Leaderboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stockList: null,
      valuations: [],
      i: 0
    };
  }

  getTickers = () => {
    return fetch(`${process.env.API_URI}/api/v1/reuters/tickers`)
      .then((res) => res.json())
      .then((res) => {
        let stockList = [];

        for (let element in res.recordset) {
          stockList.push(res.recordset[element]);
        }

        this.setState({ stockList });

        this.getStock(stockList[0].ticker);
      });
  };

  componentWillMount = () => {
    this.getTickers();
  };

  getStock = (symbol) => {
    return getStockData(symbol)
      .then((res) => {
        return getValuation(symbol, res.fmpData, res.ivvData, res.reutersData, null);
      })
      .then((res) => {
        const { i, stockList } = this.state;
        const data = {
          symbol,
          valuation: res
        };

        this.setState({
          valuations: this.state.valuations.concat(data)
        });

        if (i < stockList.length - 1) {
          this.setState({ i: i + 1 });
          this.getStock(stockList[i + 1].ticker);
        }
      })
      .catch((err) => {
        console.log('HERE');
        console.log(err);
        const { i, stockList } = this.state;
        if (i < stockList.length - 1) {
          this.setState({ i: i + 1 });
          this.getStock(stockList[i + 1].ticker);
        }
      });
  };

  render = () => {
    const { valuations } = this.state;

    const symbols = valuations.map((data, index) => {
      return (
        <tr key={index}>
          <td className="pa3 tl">{data.symbol}</td>
          <td className="pa3 tl">{data.valuation.irPractical}</td>
          <td className="pa3 tl">{data.valuation.irPotential}</td>
          <td className="pa3 tl">{data.valuation.practicalValuation}</td>
          <td className="pa3 tl">{data.valuation.roundedValuation}</td>
          <td className="pa3 tl">{data.valuation.priceMomentum}</td>
          <td className="pa3 tl">{data.valuation.theoreticalGDefault}</td>
        </tr>
      );
    });

    return (
      <table className="collapse br2 pa3 w-100 mw9 center bg-white">
        <thead>
          <tr>
            <th className="pa3 tl f6 v-top">Symbol</th>
            <th className="pa3 tl f6 v-top">irPractical</th>
            <th className="pa3 tl f6 v-top">irPotential</th>
            <th className="pa3 tl f6 v-top">practicalValuation</th>
            <th className="pa3 tl f6 v-top">roundedValuation</th>
            <th className="pa3 tl f6 v-top">priceMomentum</th>
            <th className="pa3 tl f6 v-top">theoreticalGDefault</th>
          </tr>
        </thead>
        <tbody>{symbols}</tbody>
      </table>
    );
  };
}

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/components/Leaderboard.js